import { useQuery } from 'react-apollo';

import { getApolloClient, logErrorMessage } from '@atlassian/ptc-common';

import CloudUserQuery from './CloudUser.graphql';
import { type UserQueryProps, type UserQueryResp } from './types';

function useCloudUser({ userId }: UserQueryProps): UserQueryResp {
	const { loading, error, data } = useQuery(CloudUserQuery, {
		client: getApolloClient(),
		variables: {
			userId,
			_withCloudId: true,
		},
		skip: !userId,
	});

	if (error) {
		logErrorMessage('useCloudUser', error);
	}

	const cloudUser = !error && !loading ? data?.CloudUser : {};

	return {
		data: {
			...cloudUser,
			userFullName: cloudUser?.fullName || '',
		},
		isLoading: loading,
		hasError: !!error || (!loading && !data?.CloudUser),
		error,
	};
}

export default useCloudUser;
